(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (!io || reduce) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  function initAcordeon(root) {
    root.querySelectorAll('[data-mt-acc]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return; wrap.dataset.mtInit = '1';
      var items = wrap.querySelectorAll('.mt-acc-item');
      var imgs = wrap.querySelectorAll('.mt-acc-media img');
      items.forEach(function (item, i) {
        var btn = item.querySelector('.mt-acc-btn');
        btn.addEventListener('click', function () {
          items.forEach(function (o, j) {
            var open = j === i;
            o.classList.toggle('is-open', open);
            o.querySelector('.mt-acc-btn').setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        });
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return; item.dataset.mtInit = '1';
      var q = item.querySelector('.mt-faq-q');
      q.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initMagnetico(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('[data-mt-magnet]').forEach(function (btn) {
      if (btn.dataset.mtInit) return; btn.dataset.mtInit = '1';
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 8) + 'px,' + (y * 6) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function initProducto(root) {
    root.querySelectorAll('[data-mt-producto]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return; wrap.dataset.mtInit = '1';
      var principal = wrap.querySelector('.mt-pp-principal img');
      var thumbs = wrap.querySelectorAll('.mt-pp-thumb');
      function verFoto(src, alt, activeIdx) {
        if (!principal || !src) return;
        principal.src = src; if (alt != null) principal.alt = alt;
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === activeIdx); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { verFoto(t.dataset.src, t.dataset.alt, i); });
      });

      var dataEl = wrap.querySelector('[data-mt-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var input = wrap.querySelector('input[name="id"]');
      var boton = wrap.querySelector('.mt-pp-comprar');
      var botonTexto = wrap.querySelector('.mt-pp-comprar-texto');
      var precio = wrap.querySelector('.mt-actual');
      var tachado = wrap.querySelector('.mt-pp-precio s');
      var fmt = wrap.dataset.moneda || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, n);
      }
      function actualizar() {
        var sel = [];
        wrap.querySelectorAll('.mt-pp-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel[parseInt(fs.dataset.index, 10)] = c ? c.value : null;
        });
        var v = variantes.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
        if (!v) { boton.disabled = true; botonTexto.textContent = boton.dataset.noDisponible; return; }
        input.value = v.id;
        precio.textContent = dinero(v.price);
        if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        boton.disabled = !v.available;
        botonTexto.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
        if (v.featured_image && v.featured_image.src) verFoto(v.featured_image.src, v.featured_image.alt, -1);
      }
      wrap.querySelectorAll('.mt-pp-opcion input').forEach(function (r) { r.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root); initAcordeon(root); initFaq(root); initMagnetico(root); initProducto(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
